const getMimeTypeFromFileType = (fileType: string) => {
  switch (fileType) {
    case 'XLSX':
      return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    case 'XLS':
      return 'application/vnd.ms-excel';
    case 'CSV':
      return 'text/csv;charset=utf-8;';
    default:
      console.error('Unsupported file type:', fileType);
  }
};

export async function exportSpreadsheet({
  jsonData,
  filename = 'data',
  fileType = 'csv',
  sheetName = 'Sheet1',
}: {
  jsonData: Record<string, object>[];
  filename?: string;
  fileType?: string;
  sheetName?: string;
}) {
  try {
    const { utils, write } = await import(/* webpackChunkName: "xlsx" */ 'xlsx');

    // Create a new workbook
    const workbook = utils.book_new();

    // Convert JSON data to worksheet
    const worksheet = utils.json_to_sheet(jsonData);

    // Add the worksheet to the workbook
    utils.book_append_sheet(workbook, worksheet, sheetName);

    // Get the correct MIME type based on fileType
    const mimeType = getMimeTypeFromFileType(fileType);

    // Generate the file
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- xlsx types it as any
    const outputData = write(workbook, {
      bookType: fileType.toLowerCase() as 'xlsx' | 'xls' | 'csv',
      type: 'array',
    });

    // Convert output to Blob
    const blob = new Blob([outputData], { type: mimeType });

    // Create a download link
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', `${filename}.${fileType.toLowerCase()}`);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    console.log(`File "${filename}.${fileType}" has been downloaded.`);
  } catch (error) {
    console.error(`Error converting JSON to ${fileType}:`, error);
  }
}
